import clsx from "clsx";
import React, { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { RoundButton } from "../../ui/Button/Button";
import { CrossIcon } from "../../ui/icons/CrossIcon";

type SearchFiltersProps = {
  children: ReactNode;
  loading: boolean;
  onClose(): void;
};

export const FiltersPanel: FunctionComponent<SearchFiltersProps> = ({
  children,
  loading,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="flex justify-between items-start mb-4">
        <header>
          <h3 className="text-xl font-medium">{t("searchResults.filters")}</h3>
          <h6 className="text-sm font-light">
            {t("searchResults.filtersSubtitle")}
          </h6>
        </header>
        <RoundButton
          aria-label="closeFiltersPanel"
          className="border-2 border-ink p-0 min-h-0 text-2xl leading-[0.1em] overflow-hidden"
          onClick={onClose}
        >
          <CrossIcon />
        </RoundButton>
      </div>
      <form
        className={clsx(
          "space-y-4 text-ink-2 text-lg transition-opacity",
          loading && "opacity-40 pointer-events-none"
        )}
        onSubmit={(e): void => {
          e.preventDefault();
          onClose();
        }}
      >
        {children}
      </form>
    </section>
  );
};
